var exports = {
  "VH": "FeedLinkPreview.module__preview___d3BLc3",
  "Nr": "FeedLinkPreview.module__card___d3BLc3",
  "Mn": "FeedLinkPreview.module__provider___d3BLc3",
  "h_": "FeedLinkPreview.module__description___d3BLc3",
  "Sl": "FeedLinkPreview.module__image___d3BLc3",
  "Qq": "FeedLinkPreview.module__text___d3BLc3",
  "DD": "FeedLinkPreview.module__title___d3BLc3",
};

module.exports = exports;
